/*
 * uploadWidgetTableDirective
 * */

import templateUrl from './uploadWidgetTable.html';
import controller from './uploadWidgetTable.controller';
import './uploadWidgetTable.scss';

const uploadWidgetTableDirective = () => {
	return {
		scope: {
			row: '<'
		},
		controller,
		controllerAs: '$ctrl',
		bindToController: true,
		restrict: 'E',
		templateUrl,
		link(/*scope, element, attr, ctr*/) {},
		replace: true
	};
};

export default uploadWidgetTableDirective;
